import { render } from "./hostTopicInfo.vue?vue&type=template&id=ca17a84a&scoped=true"
import script from "./hostTopicInfo.vue?vue&type=script&lang=js"
export * from "./hostTopicInfo.vue?vue&type=script&lang=js"

import "./hostTopicInfo.vue?vue&type=style&index=0&id=ca17a84a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca17a84a"]])

export default __exports__